import { useQuery } from '@tanstack/react-query';
import { getLabourItemDefinitions } from '../api/labourItemsApi';
import { useAuthStore } from '../../auth/stores/authStore';
import { labourDefinitionKeys } from './labourDefinitionKeys';

export const useAvailableLabourItems = (enabled: boolean = true) => {
  const token = useAuthStore(state => state.token);

  return useQuery({
    queryKey: labourDefinitionKeys.lists(),
    queryFn: getLabourItemDefinitions,
    enabled: enabled && !!token,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
